import './widget_dimensions.js.coffee'

class Common.WidgetDimensionTranslator
  DIMENSIONS = Common.WidgetDimensions

  translate: (dimension, {attributeName} = {}) =>
    switch dimension
      when DIMENSIONS.TAXONOMIC_ATTRIBUTE, DIMENSIONS.HIERARCHICAL_ATTRIBUTE then attributeName
      when DIMENSIONS.FILTERED_TAXONOMIC_ATTRIBUTE then @_filteredTranslation(attributeName)
      else @_translate(dimension)

  _translate: (dimension) ->
    switch (dimension)
      when DIMENSIONS.GROUP then @_translation('groups')
      when DIMENSIONS.FILTERED_GROUP then @_filteredTranslation(@_translation('groups'))
      when DIMENSIONS.SUBTYPE then @_translation('subtype')
      when DIMENSIONS.TICKET_STATUS then @_translation('status')
      when DIMENSIONS.ASSIGNED_OPERATOR then @_translation('assigned_advisor')
      when DIMENSIONS.ASSIGNED_GROUP then @_translation('users_group')
      when DIMENSIONS.CLOSED_CONVERSATIONS_PER_AGENT then @_translation('closed_conversations_per_agent')

  _filteredTranslation: (translation) ->
    "#{translation} (#{I18n.t('customer_visual_mode.filters.filtered')})"

  _translation: (path) ->
    I18n.t("customer_visual_mode.filters.#{path}")
